// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"96e92c87","387":"c75ae7b0","503":"616b9532","521":"f5a8410f","623":"86dc001f","650":"7e1d7dd9","887":"517d72c3"}[chunkId] + ".chunk.js";
};